import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const requireContext = require.context('./modules', false, /.*\.js$/);

const modules = requireContext
    .keys()
    .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
    .reduce((modules, [name, module]) => {
        if (module.namespaced === undefined) {
            module.namespaced = true;
        }

        return { ...modules, [name]: module };
    }, {});


const persistence = new VuexPersistence({
    storage: window.localStorage,
    reducer: state => ({ layout: state.layout, auth: state.auth }),
});

export default new Vuex.Store({
    modules,
    plugins: [persistence.plugin],
});
